import pf1 from '../../../assets/pf1.jpg'
import pf2 from '../../../assets/pf2.jpg'
import pf3 from '../../../assets/pf3.jpg'

const CompanyProfile = props => {

    return <div className="company-profile">
        <div className='introduce'>
            <h1>企业简介</h1>
            <div className='desc'>
                <p>
                    我们是一家专注于人工智能与医疗健康领域融合创新的高科技企业，致力于通过前沿技术研发和产业化应用，推动医疗健康服务的智能化升级。
                </p>
                <p>
                    公司整合人工智能、大数据、机器人等核心技术，构建了覆盖医疗全场景的智能化解决方案体系。
                </p>

            </div>
        </div>
        <div className="content-block">
            <img src={pf1} alt="" />
            <div className='buttom-content'>
                <h2>连接用户与智能</h2>
                <p>让医疗更便捷更多彩</p>
            </div>
        </div>

        <div className="content-block">
            <img src={pf2} alt="" />
            <div className='buttom-content'>
                <h2>连接医疗与科技</h2>
                <p>数字化助手，助力产业升级</p>
            </div>

        </div>
        <div className="content-block">
            <img src={pf3} alt="" />
            <div className='buttom-content'>
                <h2>连接现在与未来</h2>
                <p>探索面向未来的创新医疗科技</p>
            </div>
        </div>
    </div>
}

export default CompanyProfile
